module.exports = __webpack_public_path__ + "img/5.bb692db9.jpg";